<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <!-- ① 国家/商户联动级联选择器（替换原来的 business_name + business_id 两个输入框） -->
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true, value: 'name', label: 'name', expandTrigger: 'hover' }" clearable
          placeholder="Country/Business" @change="cascaderChange" style="width: 200px"></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
      </el-form-item>
    </el-form>
    <!-- 列表 -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 1152px;">
      <el-table-column prop="id" label="ID" width="60"></el-table-column>
      <el-table-column prop="business_name" label="Business Name" width="150"></el-table-column>
      <el-table-column prop="amount" label="Amount" width="120"></el-table-column>
      <el-table-column prop="usdt_amount" label="USDT Amount" width="130"></el-table-column>
      <el-table-column prop="usdt_rate" label="Rate" width="100"></el-table-column>
      <el-table-column prop="withdraw_fee" label="Withdraw Fee" width="120"></el-table-column>
      <el-table-column prop="country" label="Country" width="100"></el-table-column>
      <el-table-column prop="system_name" label="System Name" width="150"></el-table-column>
      <el-table-column prop="save_time" label="Save Time" width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.save_time | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="160">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit / Add 弹窗 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")'>
      <el-form label-width="150px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Country/Business" prop="business_name">
          <el-cascader :options="country_business" size="small"
            :props="{ checkStrictly: true, value: 'name', label: 'name', expandTrigger: 'hover' }" clearable
            placeholder="Country/Business" v-model="editForm.cascaderValue" @change="editCascaderChange"
            style="width: 100%"></el-cascader>
        </el-form-item>
        <el-form-item label="USDT Amount" prop="usdt_amount">
          <el-input size="small" v-model="editForm.usdt_amount" placeholder="USDT amount" clearable
            @input="calcAmount"></el-input>
        </el-form-item>
        <el-form-item label="Rate" prop="usdt_rate">
          <el-input size="small" v-model="editForm.usdt_rate" placeholder="Exchange rate" clearable
            @input="calcAmount"></el-input>
        </el-form-item>
        <el-form-item label="Withdraw Fee" prop="withdraw_fee">
          <el-input size="small" v-model="editForm.withdraw_fee" placeholder="Withdraw fee" clearable></el-input>
        </el-form-item>
        <el-form-item label="Amount">
          <el-input size="small" :value="editForm.amount" placeholder="Auto calculated" disabled>
            <template slot="append">= USDT × Rate</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="submitForm('editForm')">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  withdrawalList,
  withdrawalSave,
  withdrawalDelete,
  getCountryBusiness,       // ② 新增：获取国家/商户树形数据
} from '../../api/apiFun'
import {
  timestampToTime,
  cascaderChange,             // ③ 新增：联动选择工具函数
} from '@/utils/util'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false,
      editFormVisible: false,
      title: 'Add',
      editForm: {
        id: '',
        cascaderValue: [],  // 级联选择器双向绑定值 [country, business_name]
        country: '',
        business_name: '',
        business_id: '',
        amount: '',
        usdt_amount: '',
        usdt_rate: '',
        withdraw_fee: '',
      },
      rules: {
        business_name: [{
          required: true,
          message: 'Please select country/business',
          trigger: 'change'
        }],
        usdt_amount: [{
          required: true,
          message: 'Please enter the usdt amount',
          trigger: 'blur'
        }],
        usdt_rate: [{
          required: true,
          message: 'Please enter the usdt rate',
          trigger: 'blur'
        }],
      },
      params: {
        page: 1,
        limit: 10,
        country: '',          // ④ 新增：国家筛选参数
        business_name: '',    // 由联动选择器写入
      },
      listData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      country_business: [],   // ⑤ 新增：存储国家/商户树形数据
    }
  },
  components: {
    Pagination
  },
  filters: {
    timestampToTime(timestamp) {
      return timestampToTime(timestamp)
    }
  },
  created() {
    this.getdata(this.params)
    this.getCountryBusiness()  // ⑥ 初始化时拉取联动数据
  },
  methods: {
    // ⑦ 拉取国家/商户树形数据
    getCountryBusiness() {
      getCountryBusiness().then(res => {
        if (res.code == 400) {
          this.$message({ type: 'info', message: res.msg })
        } else {
          this.country_business = res.datas
        }
      }).catch(() => {
        this.$message.error('Failed to obtain business list, please try again later!')
      })
    },
    // ⑧ 级联选择器回调：value[0]=国家 value[1]=商户名称
    cascaderChange(value) {
      var result = cascaderChange(value)
      this.params.country = result[0] || ''
      this.params.business_name = result[1] || ''
    },
    // 弹窗内级联选择器回调：value[0]=国家 value[1]=商户名称
    // amount 自动计算：usdt_amount * usdt_rate
    calcAmount() {
      const usdt = parseFloat(this.editForm.usdt_amount)
      const rate = parseFloat(this.editForm.usdt_rate)
      if (!isNaN(usdt) && !isNaN(rate)) {
        this.editForm.amount = (usdt * rate).toFixed(2)
      } else {
        this.editForm.amount = ''
      }
    },
    // 弹窗内级联选择器回调：value[0]=国家 value[1]=商户名称
    editCascaderChange(value) {
      var result = cascaderChange(value)
      this.editForm.country = result[0] || ''
      this.editForm.business_name = result[1] || result[0] || ''
    },
    // 获取列表
    getdata(parameter) {
      this.loading = true
      withdrawalList(parameter).then(res => {
        this.loading = false
        if (res.code == 400) {
          this.$message({ type: 'info', message: res.msg })
        } else {
          this.listData = res.datas.list
          this.pageparm.currentPage = this.params.page
          this.pageparm.pageSize = this.params.limit
          this.pageparm.total = res.datas.count
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('Failed to get list, please try again later!')
      })
    },
    // 分页
    callFather(parm) {
      this.params.page = parm.currentPage
      this.params.limit = parm.pageSize
      this.getdata(this.params)
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getdata(this.params)
    },
    // 显示Edit/Add弹窗
    handleEdit(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = 'Edit'
        this.editForm.id = row.id
        this.editForm.country = row.country || ''
        this.editForm.business_name = row.business_name
        this.editForm.business_id = row.business_id
        this.editForm.amount = row.amount
        this.editForm.usdt_amount = row.usdt_amount
        this.editForm.usdt_rate = row.usdt_rate
        this.editForm.withdraw_fee = row.withdraw_fee || ''
        // 回显级联选择器：有国家则显示两级，否则只显示商户名
        this.editForm.cascaderValue = row.country
          ? [row.country, row.business_name]
          : [row.country]
      } else {
        this.title = 'Add'
        this.editForm.id = ''
        this.editForm.cascaderValue = []
        this.editForm.country = ''
        this.editForm.business_name = ''
        this.editForm.business_id = ''
        this.editForm.amount = ''
        this.editForm.usdt_amount = ''
        this.editForm.usdt_rate = ''
        this.editForm.withdraw_fee = ''
      }
    },
    // 保存
    submitForm(editData) {
      if (this.editForm.length < 2) {
        this.$message.error('Please select business')
        return
      }
      this.loading = true
      this.$refs[editData].validate(valid => {
        if (valid) {
          withdrawalSave(this.editForm).then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code == 200) {
              this.getdata(this.params)
              this.$message({ type: 'success', message: 'Saved successfully!' })
            } else {
              this.$message({ type: 'info', message: res.msg })
            }
          }).catch(() => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('Save failed, please try again later!')
          })
        } else {
          this.loading = false
          return false
        }
      })
    },
    // 删除
    handleDelete(index, row) {
      this.$confirm('Are you sure to delete this record?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        withdrawalDelete({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.listData.splice(index, 1)
            this.$message({ type: 'success', message: 'Deleted successfully!' })
          } else {
            this.$message({ type: 'info', message: res.msg })
          }
        }).catch(() => {
          this.$message.error('Delete failed, please try again later!')
        })
      }).catch(() => { })
    },
    // 关闭弹窗
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/business_settlement/withdrawal_records.vue